// Sticky Header
window.addEventListener('resize', function() {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.refresh();   
});

/*jQuery(window).bind('resize', function(e)
{
    console.log('window resized…');
    if (window.RT) clearTimeout(window.RT);
    window.RT = setTimeout(function() {
        this.location.reload(true); //false to get page from cache 
    }, 200);
});
*/

gsap.to(".header-wrapper", {
    scrollTrigger: {
        trigger: ".header-wrapper",
        start: 'top -1',
        endTrigger: "html",
        end: "99999",
        toggleClass: "is-stuck",
        pin: true,
        pinSpacing: false,
        scrub: 1,
    }
});

// Put focus on search input when modal is opened
jQuery('#search-modal').on('open.zf.reveal', function() {
    jQuery('.reveal form input[type=search]').focus();
});

jQuery('.js-mega-closemenu').on('click touchstart', function() {
    let parent = jQuery(this).parent().closest('.quadmenu-dropdown-menu').attr('id');
    let object = jQuery("#menu-item-" + parent.split("-")[1]).find('.quadmenu-caret');
    object.click();
});

jQuery(document).on('click touchstart', '.austin-mobile-menu .click', function() {
    let id = jQuery(this).parent().attr('id');
    let closed = jQuery(this).parent().find('.quadmenu-dropdown-menu').is(":hidden")
    jQuery('.austin-mobile-menu ul.quadmenu-navbar-nav > li').each(function() {
        if(closed) {
            if(jQuery(this).attr('id') != id) {
                jQuery(this).addClass('hide');
            } 
        } else {
            jQuery(this).removeClass('hide');
        }

    });
});

jQuery('.hamburger').on('click touchstart', function() {
    
    if(jQuery(this).attr('aria-expanded') == 'false') {
        jQuery('.stack').addClass('hide').removeClass('show');
        jQuery('.close').addClass('show').removeClass('hide');        
    } else {
        jQuery('.stack').addClass('show').removeClass('hide');
        jQuery('.close').addClass('hide').removeClass('show');
        
        jQuery('a.quadmenu-dropdown-toggle').each(function() {
            if(jQuery(this).parent().hasClass('open')) {
                jQuery(this).parent().removeClass('open');
                jQuery('.quadmenu-item').each(function() {
                    jQuery(this).removeClass('hide');
                }); 
            }            
        });
    }
});

function updateURLParameter(url, param, paramVal){
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];

    /* Remove Pagination */
    baseURL = baseURL.replace(/page\/[0-9]*\//gm, "");

    var additionalURL = tempArray[1];
    var temp = "";
    if (additionalURL) {
        tempArray = additionalURL.split("&");
        for (var i=0; i<tempArray.length; i++){

            if(tempArray[i].split('=')[0] != param 
                && tempArray[i].split('=')[1] != "all"
                && tempArray[i].split('=')[0] != "pagenum"){
                newAdditionalURL += temp + tempArray[i];
                temp = "&";
            } 
        }
    }

    var rows_txt = "";
    if(paramVal != "all") {
        rows_txt = temp + "" + param + "=" + paramVal;
    } 

    return baseURL + "?" + newAdditionalURL + rows_txt;
}

function projectFilters(category, selected) {

    var newURL = updateURLParameter(window.location.href, category, selected);
    window.history.replaceState('', '', newURL);
    location.href = newURL;    
}

jQuery(document).on('change', '.filter-select', function() {
    let category = jQuery(this).data('category');
    let selected = jQuery(this).val();
    projectFilters(category,selected);
});

jQuery(document).on('focus', '.filter-text', function() {
    jQuery(this).data('old', jQuery(this).val());
});

jQuery(document).on('change', '.filter-text', function() {
    if(jQuery(this).data('old') != jQuery(this).val()) {
        let category = jQuery(this).data('category');
        let selected = jQuery(this).val();
        if(selected != "") {
            projectFilters(category,selected);
        } else {
            projectFilters(category,"all");
        }
    }
});

// Handling Related Card height
jQuery( document ).ready(function() {
    jQuery(".blog-related-cards .card").each(function() {
        let excerpt = jQuery(this).find('.excerpt');
        let header = jQuery(this).find('h2');

        //excerpt.css('max-height',excerpt.height() - header.height());
        //excerpt.css('min-height',excerpt.height() - header.height());
        
    });
});

// Handling Proper sentance casing 
jQuery(document).ready(function() {
    jQuery(".menu-item-has-children .sub-menu .menu-item a").each(function() {
        var $obj = $(this);
        console.log($obj.text());
        $obj.addClass("no-casing");
    });
});

// Open Social Media Links in New Window
jQuery(document).ready(function() {
    jQuery(".mega-social-links a").each(function() {
        $(this).attr('target', '_blank');
    });
});

